import { useState, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";
import { AuthContext } from "../AuthContext";

function LinkView() {
  const { token } = useContext(AuthContext);
  const navigate = useNavigate();
  const fileRef = useRef();

  const [file, setFile] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const uploadFile = async () => {
    if (!file) return setError("Please select a file");

    setLoading(true);
    setError("");
    setSuccessMsg("");

    const formData = new FormData();
    formData.append("file", file);

    try {
      await api.post("/links/upload", formData, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setSuccessMsg("✅ Link successfully generated");
      setFile(null);
      fileRef.current.value = "";

      // auto dismiss after 3 seconds
      setTimeout(() => setSuccessMsg(""), 3000);

    } catch (err) {
      setError(err.response?.data?.message || "Upload failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-container">
      <header className="admin-header">
        <h2 className="admin-title">Link Creation</h2>
        <button className="admin-btn" onClick={() => navigate("/admin/upload")}>
          Back
        </button>
      </header>

      <div className="admin-card">
        <input
          ref={fileRef}
          type="file"
          onChange={e => setFile(e.target.files[0])}
        />

        {error && <div className="error-msg">{error}</div>}
        {successMsg && <div className="success-msg">{successMsg}</div>}

        <button className="upload-btn" onClick={uploadFile} disabled={loading}>
          {loading ? "Generating..." : "Generate Download Link"}
        </button>
      </div>
    </div>
  );
}

export default LinkView;
